import { render, staticRenderFns } from "./ModesPage.vue?vue&type=template&id=5bf6f29c&scoped=true&"
import script from "./ModesPage.vue?vue&type=script&lang=ts&"
export * from "./ModesPage.vue?vue&type=script&lang=ts&"
import style0 from "./ModesPage.vue?vue&type=style&index=0&id=5bf6f29c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf6f29c",
  null
  
)

export default component.exports